import { render, staticRenderFns } from "./ProducerCard.vue?vue&type=template&id=e5d4a40a"
import script from "./ProducerCard.vue?vue&type=script&lang=js"
export * from "./ProducerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports